import { render, staticRenderFns } from "./ProductBrand.vue?vue&type=template&id=72e2807c&scoped=true"
import script from "./ProductBrand.vue?vue&type=script&lang=js"
export * from "./ProductBrand.vue?vue&type=script&lang=js"
import style0 from "./ProductBrand.vue?vue&type=style&index=0&id=72e2807c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e2807c",
  null
  
)

export default component.exports